import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueMoment from 'vue-moment';
import VueIntro from 'vue-introjs';
import VueToast from 'vue-toast-notification';
import VueSweetalert2 from 'vue-sweetalert2';
import VueTheMask from 'vue-the-mask'
import VueGtag from 'vue-gtag';
import money from 'v-money';
import Autocomplete from '@trevoreyre/autocomplete-vue';
import MetaPixel from './plugins/metaPixel';

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';
import './app.scss'
import 'intro.js/introjs.css';
import 'intro.js/themes/introjs-modern.css'
import 'vue-toast-notification/dist/theme-sugar.css';
// import '@trevoreyre/autocomplete-vue/dist/style.css';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

const moment = require('moment')
require('moment/locale/pt-br');

Vue.use(VueSweetalert2);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueMoment, { moment });
Vue.use(VueIntro);
Vue.use(VueToast);
Vue.use(VueTheMask);
Vue.use(money, { precision: 4 })
Vue.use(Autocomplete);

Vue.use(VueGtag, {
  config: { id: 'G-X6CVZJY0QN' }
}, router);

// Meta Pixel (Facebook/Instagram tracking). Carrega so se a env
// VUE_APP_META_PIXEL_ID estiver definida no .env do client; senao
// vira no-op silencioso (dev/hom sem pixel real).
Vue.use(MetaPixel);

// PageView do Meta Pixel em navegacao SPA. O snippet do plugin ja
// dispara PageView no init; este hook cobre as navegacoes
// subsequentes do Vue Router (sem reload do browser).
//
// Usa Vue.prototype.$fbqTrack (do plugin metaPixel) em vez de
// window.fbq direto: assim, se VUE_APP_META_PIXEL_ID estiver vazio,
// continua no-op mesmo que algum outro script (GTM, snippet futuro)
// crie window.fbq. A garantia de "sem env = sem tracking" fica
// centralizada no plugin.
router.afterEach(() => {
  if (typeof Vue.prototype.$fbqTrack === 'function') {
    Vue.prototype.$fbqTrack('PageView');
  }
});

Vue.config.productionTip = false

// axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'https://genial-prev.herokuapp.com/api' : '/api';
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000/api' : '/api';

axios.interceptors.response.use(response => {
  return response;
}, error => {
  if (!error.response) return Promise.reject(error);

  if (error.response.status === 401) {
    store.dispatch('LOGOUT');
  }

  // Feature gate (backend bloqueou via requireFeature). Acompanha o
  // guard hasFeature do router — caso o user atinja a API por algum
  // caminho que escapou do guard (link direto, follow de hash, etc.),
  // redirecionamos pra tela de upgrade.
  if (error.response.status === 403 && error.response.data && error.response.data.code === 'FEATURE_NOT_AVAILABLE') {
    const feature = error.response.data.feature;
    // Evita loop se ja estiver em /upgrade
    if (router.currentRoute.path !== '/upgrade') {
      router.push({ path: '/upgrade', query: { feature, redirect: router.currentRoute.fullPath } }).catch(() => {});
    }
  }

  return Promise.reject(error);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
